import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import {calculators}  from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';
// R4 perf: removed dead `import { Chart, registerables } from 'chart.js/auto'`.
// Chart is created in ppfCalculator (and other calculators) — this file only
// uses ppfCalculator.methods.removeCommas / formatNumber utilities. Leaving the
// import would force chart.js into the main bundle even if dynamic in the rest.

const wealth = {
    variables :{
        wealthNextButton : '.wealth__buttons--next',
        wealthPrevButton : '.wealth__buttons--prev',
        wealthFormSubmit : '.wealth__forms',
        wealthAnwers: '.wealth__wrapper--answers',
        wealthAmountRupee:'.chli__calculator--label',
        wealthTextPlaceholder: '{amount}',
        wealthTextAmountInput:'.wealth--input',
        wealthTextAmountDetails:'.wealth__input-div',
        wealthTextAnswersButton:'.wealth__answer-buttons--prev',
        wealthDetails:'.wealth__forms--details-1',
        wealthStep : '.wealth__wrapper--step',
        wealthAnswersWrap:'.wealth__graph-details--details',
        wealthgreetingText : '.wealth__answers-greeting',
        wealthAnswersMoney:'.wealth__answers-money',
        wealthAnswerMessage: '.wealth__answers-message',
        wealthInvestTime : '.wealth__invest-time',
        wealthCorpusCreated:'.wealth__corpus-created'
    },
    methods : {
        replaceAmountInput : (el)=>{
            const $el = $(el);
            const {wealthTextPlaceholder,wealthTextAmountInput,wealthAmountRupee} = wealth.variables;
            let termInsuranePlaceholderText = wealthTextPlaceholder;
            if($el.hasClass('total-amount')){
                termInsuranePlaceholderText = '{totalAmount}';
            } else if($el.hasClass('total-year')){
                termInsuranePlaceholderText = '{totalYear}';
            } else if($el.hasClass('saved-amount')){
                termInsuranePlaceholderText = '{savedAmount}';
            }  else if($el.hasClass('calculated-interest')){
                termInsuranePlaceholderText = '{expectedInterest}';
            }  else if($el.hasClass('name')){
                termInsuranePlaceholderText = '{customerName}';
            } else if($el.hasClass('contact')){
                termInsuranePlaceholderText = '{phoneNumber}';
            }
            const investmentInput = $el.find(wealthTextAmountInput).parent().removeClass('d-none').detach();
            const amountText = $el.find(wealthAmountRupee);
            if(wealthAmountRupee.length > 0){
                const replacedTextEl = amountText.html().replace(termInsuranePlaceholderText, investmentInput.prop('outerHTML'));
                amountText.html(replacedTextEl);
                calculators.methods.currencyFormat();
                calculators.methods.onlyNumbers();
                calculators.methods.onlyText();
            }
        },
        handlewealth : (el)=>{
            const $el = $(el);
            const name = $el.find('.wealth__input-div.name').find('input').val();
            const totalAmount = ppfCalculator.methods.removeCommas($el.find('.wealth__input-div.total-amount').find('input').val());
            const totalYear = ppfCalculator.methods.removeCommas($el.find('.wealth__input-div.total-year').find('input').val());
            const savedAmount = ppfCalculator.methods.removeCommas($el.find('.wealth__input-div.saved-amount').find('input').val());
            const calculatedInterest = ($el.find('.wealth__input-div.calculated-interest').find('input').val());
            const replcedName = $el.find(wealth.variables.wealthgreetingText).data('text').replace('{name}', `<span class="text-blue-400">${name.split(' ')[0]}</span>`);
            $el.find(wealth.variables. wealthgreetingText).html(replcedName);
            const principal = savedAmount;
            const annualRate = calculatedInterest;
            const years = totalYear;
            let difference = 2;
            $el.find('.wealth__second-flow').find('.wealth__text').each((idx,text)=>{
               $(text).html(`${totalYear - difference + idx} year`);
            });
            let additionalCover = wealth.methods.findAdditionalCover(principal, years, totalAmount,annualRate);
            additionalCover = (additionalCover < 0) ? 0 : additionalCover;
            if(additionalCover == 0){
                $el.find(wealth.variables.wealthAnswerMessage).find('.span-heading').html(`<span class="text-red-300 font-12 leading-13">Seems Yours Goal is already achieved basis inputs provided. Please recalculate if needed!</span>`);
                $el.find(wealth.variables.wealthAnswerMessage).find('.span-text').addClass('opacity-0');
            }else{
                $el.find(wealth.variables.wealthAnswerMessage).find('.span-heading').html(`₹  ${ppfCalculator.methods.formatNumber(Math.round(additionalCover))}`);
                $el.find(wealth.variables.wealthAnswerMessage).find('.span-text').html($el.find(wealth.variables.wealthAnswerMessage).find('.span-text').data('text').replace('{totalYear}', totalYear));
                $el.find(wealth.variables.wealthAnswerMessage).find('.span-text').removeClass('opacity-0');
            }
            $el.find(wealth.variables.wealthAnswerMessage).find('.span-text').html($el.find(wealth.variables.wealthAnswerMessage).find('.span-text').data('text').replace('{totalYear}', totalYear));
            const replcedAgeValue = $el.find(wealth.variables.wealthInvestTime).data('text').replace('{investAmount}',`<span class="fw-bold">₹ ${wealth.methods.formatNumber(additionalCover.toFixed(2)*12*totalYear)}</span>`).replace('{totalYear}', totalYear);
            $el.find(wealth.variables.wealthInvestTime).html(`${replcedAgeValue}`);
            $el.find('.wealth__flow-line--data').find('.wealth__money').html(`₹ ${wealth.methods.formatNumber(additionalCover.toFixed(0)*12)}`);
            $el.find(wealth.variables.wealthCorpusCreated).find('.text').html($el.find(wealth.variables.wealthCorpusCreated).find('.text').data('text').replace('{corpusYear}',`${totalYear}th`));
            $el.find(wealth.variables.wealthCorpusCreated).find('.money').html(`₹ ${wealth.methods.formatNumber(totalAmount)}`);
        },
        formatNumber : (value)=> {
            let formattedValue = value;
            if (value >= 10000000) {
                formattedValue = (value / 10000000).toFixed(value % 10000000 === 0 ? 0 : 2) + " Cr";
            } else if (value >= 100000) {
                formattedValue = (value / 100000).toFixed(value % 100000 === 0 ? 0 : 2) + " L";
            } else if (value >= 1000) {
                formattedValue = (value / 1000).toFixed(value % 1000 === 0 ? 0 : 2) + " K";
            }
            return formattedValue;
        },
        findAdditionalCover : (currentCorpus, timePeriod, targetAccumulation, growthRate)=>{
                    // Convert the annual growth rate to a decimal
            let rate = growthRate / 100;

            // Calculate the future value of the current corpus after the time period
            let futureValueOfCorpus = currentCorpus * Math.pow((1 + rate), timePeriod);

            // Calculate the additional future value needed to reach the target accumulation
            let requiredFutureValue = targetAccumulation - futureValueOfCorpus;

            // Calculate the monthly growth rate
            let monthlyRate = rate / 12;

            // Calculate the number of months
            let numberOfMonths = timePeriod * 12;

            // Calculate the monthly investment using the formula for PMT (Future Value of an Annuity)
            let pmt = (requiredFutureValue *monthlyRate) / (Math.pow(1 + (monthlyRate*12), timePeriod) - 1);

            return pmt;
        },
        requiredValidationOnInput:function(el){
            const $el = $(el);
            $el.find("input").on(CONSTANT.eventsListners.INPUT,function(e){
            //     calculators.methods.validateRequiredFields();
            //     wealth.methods.validateAllInputFields($el,$el.find("input"));
                this.style.width = this.value.length + "ch";
                if($(this).hasClass('wealth--input-contact')){
                    const mobileValue = $(this).val();
                    if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                        e.target.value = mobileValue.slice(0, -1);
                    }
                }
            });
        },
        buildRangeErrorMessage: (template, min, max)=>{
            const fallbackTemplate = 'Please enter a value between {min} and {max}';
            return (template || fallbackTemplate).replace('{min}', min).replace('{max}', max);
        },
        validateAllInputFields : ($el, inputs)=>{
            if(inputs.hasClass('wealth--input-total-year')){
                const $field = $el.find('.wealth--input-total-year');
                localStorage.setItem('investment_Goal_Years',$field.val());
                // Only touch this field's error state when it actually has a value to
                // range-check. When it's empty, leave it alone entirely — clearing
                // unconditionally here would wipe out the "This Field is Required"
                // error that validateRequiredFields() just set moments earlier in
                // handlePrevNext, since an empty value can never be "out of range"
                // and nothing would replace the error we just erased.
                if ($field.val()) {
                    const minYear = parseInt($field.attr('data-min-value'), 10);
                    const maxYear = parseInt($field.attr('data-max-value'), 10);
                    const hasRange = !isNaN(minYear) && !isNaN(maxYear);
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error, .error-validation').remove();
                    if(hasRange && ($field.val() < minYear || $field.val() > maxYear)){
                        const errorMessage = wealth.methods.buildRangeErrorMessage($field.attr('data-error-message'), minYear, maxYear);
                        const $error = $(`<span class="error-validation">${errorMessage}</span>`);
                        $field.after($error);
                        $field.parent().addClass('error__active');
                    }
                }
            }
            if(inputs.hasClass('wealth--input-interest')){
                const $field = $el.find('.wealth--input-interest');
                // Same reasoning as wealth--input-total-year above.
                if ($field.val()) {
                    const minInterest = parseInt($field.attr('data-min-value'), 10);
                    const maxInterest = parseInt($field.attr('data-max-value'), 10);
                    const hasRange = !isNaN(minInterest) && !isNaN(maxInterest);
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error, .error-validation').remove();
                    if(hasRange && ($field.val() < minInterest || $field.val() > maxInterest)){
                        const errorMessage = wealth.methods.buildRangeErrorMessage($field.attr('data-error-message'), minInterest, maxInterest);
                        const $error = $(`<span class="error-validation">${errorMessage}</span>`);
                        $field.after($error);
                        $field.parent().addClass('error__active');
                    }
                }
            }
            if(inputs.hasClass('wealth--input-target')){
                const $field = $el.find('.wealth--input-target');
                localStorage.setItem('investment-input-target',$field.val());
                let monthlyValue = ($field.val()) ? ppfCalculator.methods.removeCommas($field.val()) : '';
                let totalDifference = (monthlyValue) ? (ppfCalculator.methods.removeCommas($el.find('.wealth--input-corpus').val())-monthlyValue): '';
                if( monthlyValue && (totalDifference < 100000)){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Target must be greater than current corpus by 1,00,000</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
            if(inputs.hasClass('wealth--input-contact')){
                const $field = $el.find('.wealth--input-contact');
                localStorage.setItem('investment-input-contact',$field.val());
                if($field.val() && !wealth.methods.validatePhoneNumber($field.val())){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Phone Number is not Correct</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
        },

        validatePhoneNumber : (value)=>{
            value = value.replace(/[^0-9]/g, '');
            if (value.length === 10 && /^[6789]\d{9}$/.test(value)) {
                return true;
            } else {
                return false;
            }
        },
        handlePrevNext : (el)=>{
            const $el = $(el);
            const { wealthNextButton ,wealthPrevButton , wealthFormSubmit,wealthAnwers } = wealth.variables;
            $el.find(wealthFormSubmit).on(CONSTANT.eventsListners.SUBMIT,function(e){
                e.preventDefault();
                calculators.methods.validateRequiredFields();
                wealth.methods.validateAllInputFields($el,$el.find('.wealth__forms--details-1.active').find("input"));
                const isError = $el.find('.wealth__forms--details-1.active').find('.error__active');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(wealthPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(wealthPrevButton).addClass('d-none');
                    $el.find(wealthNextButton).addClass('d-none');
                    $el.find(wealthAnwers).removeClass('d-none');
                    wealth.methods.handlewealth(el);
                }
            });
            $el.find(wealthPrevButton).on(CONSTANT.eventsListners.CLICK,function(){
                const isBack = calculators.methods.handleNextPrev(el,true);
                if(isBack){
                    $el.find(wealthPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(wealthPrevButton).addClass('d-none');
                }
            });
        },
        handleAllInputs:(el)=>{
            const $el = $(el);
            $el.find(wealth.variables.wealthTextAmountDetails).each((idx,details)=>{
                wealth.methods.replaceAmountInput(details);
            });
            $el.find(wealth.variables.wealthTextAnswersButton).on(CONSTANT.eventsListners.CLICK,(e)=>{
                $el.find(wealth.variables.wealthAnwers).addClass('d-none');
                $($el.find(wealth.variables.wealthDetails)[0]).addClass('active');
                $el.find(wealth.variables.wealthStep).removeClass('active');
                $($el.find(wealth.variables.wealthStep)[0]).addClass('active');
                $el.find(wealth.variables.wealthNextButton).removeClass('d-none');
                $el.find('.wealth__wrapper--mobile-steps').find('.wealth__step-text').removeClass('active');
                $($el.find('.wealth__wrapper--mobile-steps').find('.wealth__step-text')[0]).addClass('active');
            });
        },
        handleDataLayer:(el)=>{

            $(el).find('.wealth__buttons--next').on('click', function(e){

                let container=$(this).closest('.wealthCalculator')
                .find(".wealth__forms--details-1.active");

                let name=null;
                let mobile=null;

                if(container){
                    name=container.find('.wealth__input-div.name').find('.wealth--input').val();
                    mobile=container.find('.wealth__input-div.contact').find('.wealth--input').val();
                }
            let calculatorSection=$(this).closest('.wealthCalculator').find('.wealth__step-text.active').text();
            let calculatorName=$(this).closest('.wealthCalculator').find('.wealth__wrapper--title').text();
            var obj = wealth.methods.dataLayerObj(e,calculatorName,calculatorSection,name,mobile);
                createDataLayer('buttonClick', obj);
            });

            $(el).find('.wealth__buttons--prev').on('click', function(e){
            let calculatorSection=$(this).closest('.wealthCalculator').find('.wealth__step-text.active').text();
            let calculatorName=$(this).closest('.wealthCalculator').find('.wealth__wrapper--title').text();
              var obj = wealth.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });

            $(el).find('.wealth__answer-buttons--prev').on('click', function(e){
            let calculatorSection=$(this).closest('.wealthCalculator').find('.wealth__step-text.active').text();
            let calculatorName=$(this).closest('.wealthCalculator').find('.wealth__wrapper--title').text();
              var obj = wealth.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });

            $(el).find('.wealth__buttons--answer-next').on('click', function(e){
            let calculatorSection=$(this).closest('.wealthCalculator').find('.wealth__step-text.active').text();
            let calculatorName=$(this).closest('.wealthCalculator').find('.wealth__wrapper--title').text();
            var obj = wealth.methods.dataLayerObj(e,calculatorName,calculatorSection);
            createDataLayer('buttonClick', obj);
            });
        },
        dataLayerObj: function (e,pageSection,section,name,mobile) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : pageSection.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim(),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                "name": name ? name: "",
                "mobileNumber": mobile ? mobile : "",
                "countryCode" : "+91",
            };
            return obj;
        },
        init : ()=>{
            if($('.wealth').length > 0){
                $('.wealth').each((idx,ele)=>{
                    wealth.methods.handlePrevNext(ele);
                    wealth.methods.handleAllInputs(ele);
                    wealth.methods.requiredValidationOnInput(ele);
                    wealth.methods.handleDataLayer(ele);
                });
            }
        }
    }
};
$(()=>{
    wealth.methods.init();
});
